<template>
  <v-container class="my-16 px-16">
    <div>
      <h1>Support</h1>
      <v-form ref="supportform">
        <v-row class="mt-16">
          <v-col cols="12" lg="6">
            <v-text-field label="Name" v-model="issue.name" outlined />
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field label="Email" v-model="issue.email" outlined />
          </v-col>
          <v-col cols="12">
            <v-textarea label="Issue" v-model="issue.description" outlined />
          </v-col>
          <v-col>
            <v-btn
              :disabled="sending"
              :loading="sending"
              depressed
              :dark="!sending"
              large
              @click="send"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-container>
</template>

<script>

import { getFirestore, addDoc, collection } from "firebase/firestore"

export default {
  data() {
    return {
      issue: {
        name: null,
        email: null,
        description: null,
      },
      sending: false,
    }
  },
  methods: {
    async send() {
      if (!this.issue.name || !this.issue.email || !this.issue.description) {
        return
      }
      this.sending = true
      const issuesCollection = collection(getFirestore(), 'issues')
      await addDoc(issuesCollection, this.issue)
      this.sending = false
      this.$refs.supportform.reset()
      this.$router.push('/')
    },
  },
}
</script>
